<template>
  <ThreejsContainer class="space-droid-viewport">
    <div ref="space_droid" class="space-droid"></div>
  </ThreejsContainer>
</template>

<script>
  import ThreejsContainer from "../containers/ThreejsContainer.vue";
  import { SpaceDroidScene } from "./js/scene";
  export default {
    name: "SpaceDroid",
    components: {
      ThreejsContainer
    },
    mounted() {
      window.spaceDroidScene = new SpaceDroidScene(this.$refs.space_droid);
    }
  };
</script>

<style lang="scss" scoped>
.space-droid-viewport {
  min-height: 100vh;
  position: relative;
}

.space-droid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
}

.space-droid__canvas {
  position: relative;
}
</style>